<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      width="350"
    >
      <v-card
        class="mx-auto"
        max-width="344"
      >
        <v-card-text>
          <div>datos de la cuenta</div>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <div class="text-h5 text--primary">
            {{ numero }}
          </div>
          <div>{{ descripcion }}</div>
          <v-divider class="my-2"></v-divider>
          <div>Saldo total</div>
          <div class="text-h4 text--primary">
            $ {{ saldoTotal | formatToTwoDecimals }}
          </div>
          <v-divider class="my-1" inset></v-divider>
          <div>
            <v-icon small>mdi-ticket-account</v-icon> Saldo $ subsidiado<br>
          </div>
          <div class="text-body-1 text--primary">
            $ {{ saldoUsuario | formatToTwoDecimals }}<br>
          </div>
          <v-divider class="my-1" inset></v-divider>
          <div>
            <v-icon small>mdi-cash</v-icon> Saldo $ sin subsidio<br>
          </div>
          <div class="text-body-1 text--primary">
            $ {{ saldoSinSubsidio | formatToTwoDecimals }}
          </div>
          <v-divider class="my-1" inset></v-divider>
          <div>
            <v-icon small>mdi-storage-tank-outline</v-icon> Kilos subsidiados a favor<br>
          </div>
          <div v-if="$can('transacciones.transferencias') && kilosSubsidio > 0 && !inactivo && !cerrada" class="text-body-1 text--primary">
            <a @click="onTransferirSubsidio">{{ kilosSubsidio | formatToThreeDecimals }} Kg. <v-icon>mdi-swap-horizontal-bold</v-icon></a>
          </div>
          <div v-else-if="kilosSubsidio > 0" class="text-body-1 text--primary">
            {{ kilosSubsidio | formatToThreeDecimals }} Kg.
          </div>
          <div v-else class="text-body-1 text--primary">
            0,00 Kg.
          </div>
          <v-divider class="my-1" inset></v-divider>
          <div>
            <v-icon small>mdi-cash</v-icon> Dinero a favor<br>
          </div>
          <div class="text-body-1 text--primary">
            $ {{ creditoDemas | formatToTwoDecimals }}
          </div>
        </v-card-text>
        <v-list-item
          :class="cuentaSelected && !inactivo && !cerrada ? 'brown lighten-2' : 'grey'"
          :disabled="!cuentaSelected || inactivo || cerrada"
          dark
          @click="onNuevoSubsidio"
        >
          <v-list-item-icon>
            <v-icon>mdi-keyboard-f1</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Descarga subsidio</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          :class="cuentaSelected && !inactivo && !cerrada ? 'brown lighten-2' : 'grey'"
          dark
          :disabled="!cuentaSelected || inactivo || cerrada"
          @click="onNuevoCredito"
        >
          <v-list-item-icon>
            <v-icon>mdi-keyboard-f2</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Nuevo pago</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          :class="cuentaSelected && !inactivo && !cerrada ? 'brown lighten-2' : 'grey'"
          dark
          :disabled="!cuentaSelected || inactivo || cerrada"
          @click="onNuevoDebito"
        >
          <v-list-item-icon>
            <v-icon>mdi-keyboard-f3</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Nueva venta</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <resumen-print />
        <v-divider></v-divider>
        <recalcular-saldo />
        <v-divider></v-divider>
        <v-list-item
          @click="onCuentaEdit"
          :disabled="!cuentaSelected"
        >
          <v-list-item-icon>
            <v-icon>mdi-keyboard-f7</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Editar cuenta</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <imputaciones-export v-if="$can('transacciones.imputaciones')"/>
      </v-card>
    </v-navigation-drawer>

    <cuentas-edit v-model="dialogEditCuenta" />
    <creditos-subsidio v-model="dialogCreateSubsidio" />
    <creditos-create v-model="dialogCreateCredito" />
    <debitos-create v-model="dialogCreateDebito" />
    <transferencia-subsidio v-model="dialogTransferenciaSubsidio" />
    <cuenta-refresh />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResumenPrint from '@/pages/cuentas/PrintComponent'
import CuentasEdit from '@/pages/cuentas/EditComponent'
import DebitosCreate from '@/pages/debitos/CreateComponent'
import CreditosCreate from '@/pages/creditos/CreateComponent'
import CreditosSubsidio from '@/pages/creditos_subsidio/CreateComponent'
import TransferenciaSubsidio from '@/pages/transferencias/Main'
import ImputacionesExport from '@/pages/imputaciones/ExportComponent'
import Recalcular from '@/pages/cuentas/RecalcularComponent'
import Refresh from '@/pages/cuentas/RefreshComponent'
import PrecioMixin from '@/mixins/Precios'
export default {
  name: 'CuentasNavigationComponent',
  components: {
    'resumen-print': ResumenPrint,
    'cuentas-edit': CuentasEdit,
    'creditos-subsidio': CreditosSubsidio,
    'creditos-create': CreditosCreate,
    'debitos-create': DebitosCreate,
    'transferencia-subsidio': TransferenciaSubsidio,
    'recalcular-saldo': Recalcular,
    'cuenta-refresh': Refresh,
    'imputaciones-export': ImputacionesExport,
  },
  mixins: [PrecioMixin],
  data () {
    return {
      dialogEditCuenta: false,
      dialogCreateSubsidio: false,
      dialogCreateCredito: false,
      dialogCreateDebito: false,
      dialogTransferenciaSubsidio: false,
      drawer: true,
      precio: {
        id: null,
        vigencia: null,
        subsidio: 0,
        usuario: 0,
        pleno: 0,
      }
    }
  },
  beforeMount () {
    // Agrega el event listener en el gancho beforeMount
    window.addEventListener('keydown', this.handleKeyboard);
    this.$root.$on('update:appbarnav', this.onUpdateAppNavBar);
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
    this.$root.$off('update:appbarnav', this.onUpdateAppNavBar);
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'selectedId', 'cerrada', 'loading']),
    cuentaSelected () {
      return this.selected && this.selected.id > 0 
    },
    numero () {
      return this.selected.numero
    },
    descripcion () {
      return this.selected.descripcion
    },
    saldoTotal () {
      return this.saldoSinSubsidio + this.saldoUsuario
    },
    kilosPleno() {
      return this.selected.kilos_pleno;
    },
    saldoSinSubsidio() {
      return this.selected.saldo_pleno + (this.selected.kilos_pleno * this.precio.pleno);
    },
    saldoUsuario() {
      return this.selected.saldo_usuario
    },
    saldoSubsidio() {
      return this.selected.saldo_subsidio
    },
    kilosSubsidio() {
      return this.saldoSubsidio ? (this.saldoSubsidio / this.precio.subsidio) : 0
    },
    creditoDemas() {
      return this.selected.credito_demas
    },
    inactivo () {
      return this.selected && this.selected.inactivo;
    },
  },
  watch: {
    selectedId() {
      this.precio = this.precioByVigencia(this.$moment().format('YYYY-MM-DD'));
    }
  },
  methods: {
    onNuevoSubsidio (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateSubsidio = true
    },
    onNuevoCredito (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateCredito = true
    },
    onNuevoDebito (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateDebito = true
    },
    onCuentaEdit (event) {
      event.preventDefault()
      this.dialogEditCuenta = true
    },
    onImputaciones(event) {
      event.preventDefault();
      this.$store.dispatch('ImputacionesExport/onSave');
    },
    handleKeyboard(event) {
      // Si Ctrl está presionada, salimos ya que no queremos manejarla aquí
      if (event.ctrlKey) {
        return;
      }
      // Objeto que mapea las teclas a sus funciones correspondientes
      const keyActions = {
        'F1': this.onNuevoSubsidio,
        'F2': this.onNuevoCredito,
        'F3': this.onNuevoDebito,
        'F7': this.onCuentaEdit,
        'F8': this.onImputaciones,
      };
      // inactivo || cerrada
      // Obtenemos la función correspondiente a la tecla presionada
      const action = keyActions[event.key];
      // Si no hay una acción mapeada para esta tecla, salimos
      if (!action) {
        return;
      }
      // Verificamos si hay una cuenta seleccionada antes de ejecutar la acción
      if (!this.cuentaSelected) {
        alert('¡Primero debe seleccionar una cuenta!');
      } else if (event.key !== 'F7' && (this.inactivo || this.cerrada)) {
        alert('La cuenta está inactiva o cerrada');
      } else {
        // Ejecutamos la acción (la función) con el contexto correcto (this)
        action.call(this, event);
      }
    },
    onTransferirSubsidio(event) {
      event.preventDefault()
      this.$store.commit('Transferencias/setEdited', {
        ...this.$store.getters['Transferencias/edited'],
        saldo_subsidio: this.saldoSubsidio
      });
      this.dialogTransferenciaSubsidio = true
    },
    onUpdateAppNavBar () {
      this.drawer = !this.drawer
    },
  },
}
</script>
